import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../../utils/translations';
import actions from '../../../allowedActions';

const FlexibleDates = ({allowedActions, translations}) => {
    const showModifyBooking = allowedActions.includes(
        actions.REQUEST_TO_MODIFY_NEW
    );
    return showModifyBooking ? (
        <p>
            <b>
                {translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'tripDetails.cancelBooking.description.front'
                )}
            </b>{' '}
            {translate(
                translations,
                'trav-dash/trav-home',
                'messages',
                'tripDetails.cancelBooking.description.back'
            )}
        </p>
    ) : null;
};

export default FlexibleDates;

FlexibleDates.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.string),
    translations: PropTypes.shape({}),
};
